export class FilterService {
    public filter<T>(dataSet: T[], value: null | string | T, recursive = false, ignoreProperties: string[] = []): T[] {
        if (value === null) {
            return dataSet.slice();
        }

        if (typeof value === 'string') {
            return this.filterDataSetByProperties(dataSet, value, recursive, ignoreProperties);
        }

        return dataSet.filter(record => record === value);
    }

    private filterDataSetByProperties<T>(
        dataSet: T[],
        value: string,
        recursive: boolean,
        ignoreProperties: string[],
    ): T[] {
        const searchString = this.removeSpaces(value);

        return dataSet.filter(record => {
            const properties = this.normalizeData(record, ignoreProperties, recursive);
            return properties
                .join('')
                .toLowerCase()
                .includes(searchString);
        });
    }

    private normalizeData(record: any, ignoreProperties: string[], recursive = true): string[] {
        let properties: any[] = [];

        for (const property of Object.keys(record)) {
            if (!ignoreProperties.includes(property)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const value = record[property];
                if (typeof value === 'string') {
                    properties.push(this.removeSpaces(value));
                }
                if (recursive && typeof value === 'object') {
                    properties = properties.concat(this.normalizeData(value, ignoreProperties, true));
                }
            }
        }

        return properties;
    }

    private removeSpaces(value: string): string {
        return value.replace(/ /g, '').toLowerCase();
    }
}
